import React from "react";
import { storyblokEditable } from "@storyblok/react";

/* TBB */
import Placeholder from "utils/Placeholder";
import SimpleCentered from "components/TBB/SimpleCentered";
import Centered from "components/TBB/Centered";
import SimpleThreeColumn from "components/TBB/SimpleThreeColumn";
import SplitWithImage from "components/TBB/SplitWithImage";
import TwoColumns from "components/TBB/TwoColumns";
import TwoColumnsWithImage from "components/TBB/TwoColumnsWithImage";
import TwoColumnsWithTestimonial from "components/TBB/TwoColumnsWithTestimonial";
import WithTestimonialAndStats from "components/TBB/WithTestimonialAndStats";
import Stat from "components/TBB/Stat";
import FullWidthImage from 'components/SNC/FullWidthImage'
import ContactCentered from "components/TBB/ContactCentered";
import BrandPanelOverlappingImage from "components/TBB/BrandPanelOverlappingImage";
import BrandPanelAppScreenshot from "components/TBB/BrandPanelAppScreenshot";
import SimpleJustified from "components/TBB/SimpleJustified";
import OffsetSupportingText from "components/TBB/OffsetSupportingText";
import TestimonialsSimpleCentered from "components/TBB/TestimonialsSimpleCentered";
import Simple404 from "components/TBB/Simple404";
import CenteredAccordion from "components/TBB/CenteredAccordion";
import Hero from "components/TBB/Hero";
import DefaultContent from "components/TBB/DefaultContent"
import GoogleMap from "components/TBB/GoogleMap";
import Video from "components/TBB/Video";
import VideoAutoPlay from "components/TBB/VideoAutoPlay";
import BreadcrumbsBlock from "components/TBB/BreadcrumbsBlock";
import BackButtonBlock from "components/TBB/BackButtonBlock";
import Form from "components/TBB/Form";
import IntroTypeWide from "components/IntroTypeWide";

/* Project Specific */
import TwoColumnTitleAndText from "components/TwoColumnTitleAndText";
import BespokeDiagram from "components/SNC/BespokeDiagram";
import WorkHeader from "components/SNC/WorkHeader"
import ShowAndHide from "./ShowAndHide";
import TwoColumnImageQuote from "components/SNC/TwoColumnImageQuote"
import LogoBlock from "components/LogoBlock"
import OneColumnTextButton from "components/SNC/OneColumnTextButton"
import WorkTwoColumnCards from "components/SNC/WorkTwoColumnCards"
import ArticleHeader from "components/SNC/ArticleHeader"
import FeaturedCard from "components/SNC/FeaturedCard"
import QuoteBlockBig from "components/QuoteBlockBig";
import OneColumnText from "components/OneColumnText";
import OneColumnTextReadMore from "components/SNC/OneColumnTextReadMore";

import BigTypeStatic from "components/BigTypeStatic";
import BlogTwoColumnCards from "components/SNC/BlogTwoColumnCards";
import BigTypeScrolling from "components/BigTypeScrolling";
import BigTextLinks from "components/BigTextLinks";

const Components = {
  "hero": Hero,
  "simple-centered": SimpleCentered,
  "split-with-image": SplitWithImage,
  "centered": Centered,
  "two-columns": TwoColumns,
  "two-columns-with-image": TwoColumnsWithImage,
  "two-columns-with-testimonial": TwoColumnsWithTestimonial,
  "simple-three-column": SimpleThreeColumn,
  "with-testimonial-and-stats": WithTestimonialAndStats,
  "full-width-image": FullWidthImage,
  "stat": Stat,
  "simple-404" : Simple404,
  "brand-panel-overlapping-image": BrandPanelOverlappingImage,
  "brand-panel-app-screenshot": BrandPanelAppScreenshot,
  "simple-justified": SimpleJustified,
  "offset-with-supporting-text": OffsetSupportingText,
  "contact-centered": ContactCentered,
  "testimonial-simple-centered": TestimonialsSimpleCentered,
  "centered-accordion": CenteredAccordion,
  "default-content": DefaultContent,
  "video": Video,
  "videoautoplay": VideoAutoPlay,
  "google-map":GoogleMap,
  "breadcrumbs": BreadcrumbsBlock,
  "back-button": BackButtonBlock,
  "form": Form,
  "intro-type-wide": IntroTypeWide,
  "two-column-title-and-text": TwoColumnTitleAndText,
  "bespoke-diagram": BespokeDiagram,
  "work-header": WorkHeader,
  "show-and-hide": ShowAndHide,
  "quote-block-big": QuoteBlockBig,
  "two-column-image-quote": TwoColumnImageQuote,
  "logo-block": LogoBlock,
  "one-column-text-button": OneColumnTextButton,
  "one-column-text-read-more": OneColumnTextReadMore,
  "work-two-column-cards": WorkTwoColumnCards,
  "article-header": ArticleHeader,
  "big-type-static": BigTypeStatic,
  "blog-two-column-cards": BlogTwoColumnCards,
  "featured-card": FeaturedCard,
  "one-column-text": OneColumnText,
  "big-type-scrolling": BigTypeScrolling,
  "big-text-links": BigTextLinks,
};

const DynamicComponent = ({ blok }) => {
  if (typeof Components[blok.component] !== "undefined") {
    const Component = Components[blok.component];
    return (
      <div {...storyblokEditable(blok)} key={blok._uid}>
        <Component blok={blok}/>
      </div>
    );
  }

  return blok.component ? <Placeholder blok={blok} /> : null;
};

export default DynamicComponent;
